import { call, put, takeLatest, all } from "redux-saga/effects";
import {
  getSuggestionsStart,
  getSuggestionsSuccess,
  getSuggestionsFailure,
} from "../suggestions";
import { fetchSuggestions } from "../services/suggestion";

// Worker saga: receive action with payload (search string)
import type { SagaIterator } from "redux-saga";

function* getSuggestionsWorker(
  action: ReturnType<typeof getSuggestionsStart>
): SagaIterator {
  try {
    // action.payload is now an object { query, sellerId }
    const { query, sellerId } = action.payload;

    // Pass the whole payload or just what fetchSuggestions expects
    // Assuming fetchSuggestions accepts { query, sellerId }
    const response = yield call(fetchSuggestions, { query, sellerId });

    yield put(getSuggestionsSuccess(response.suggestions || []));
  } catch (error: any) {
    yield put(
      getSuggestionsFailure(error.message || "Failed to fetch suggestions")
    );
  }
}

function* suggestionsSagaWatcher() {
  yield takeLatest(getSuggestionsStart.type, getSuggestionsWorker);
}

function* suggestionsInitSaga() {
  // You can optionally dispatch here without payload or omit if not needed
  // yield put(getSuggestionsStart("")); // but your action requires payload
}

export default function* suggestionsRootSaga() {
  yield all([
    // suggestionsInitSaga(),
    suggestionsSagaWatcher(),
  ]);
}
